export const pageLayoutGutter = {
  padding: 'p-md gap-md md:p-lg md:gap-lg lg:px-2xl lg:gap-2xl lg:py-lg',
  paddingX: 'px-md md:px-lg lg:px-2xl',
  paddingTop: 'pt-md md:pt-lg lg:pt-lg',
  bleedX: '-mx-md md:-mx-lg lg:-mx-2xl',
  bleedBottom: '-mb-md md:-mb-lg lg:-mb-lg',
  footerPaddingY: 'pt-md pb-md md:pb-lg lg:pb-lg',
} as const;
